<template>
  <div class="systemuserlist-container">
    <div class="search-layout">
      <el-form :model="queryInfo" size="medium" label-width="90px">
        <el-col :span="12">
          <el-form-item :label="$t('manage.name20')" prop="loginName">
            <el-input v-model="queryInfo.keyword" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('manage.name2')" prop="status">
            <el-select v-model="queryInfo.status" :placeholder="$t('public.name1')" style="width:130px;" @change="getUserList">
              <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form>
      <div>
        <el-button type="primary" size="medium" @click="getPageList" v-if="buttonPerms.indexOf('user/list') > -1">{{ $t('public.name3') }}</el-button>
        <el-button size="medium" @click="restQuery">{{ $t('public.name4') }}</el-button>
      </div>
    </div>
    <div class="add-user">
      <el-button type="primary" icon="el-icon-plus" size="medium" @click="addUser" v-if="buttonPerms.indexOf('user/save') > -1">{{ $t('manage.name3') }}</el-button>
    </div>
    <el-table :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="loading">
      <el-table-column :label="$t('manage.name4')" prop="loginName" sortable></el-table-column>
      <el-table-column :label="$t('manage.name5')" prop="userName" sortable></el-table-column>
      <el-table-column :label="$t('manage.name6')" prop="roleName" sortable></el-table-column>
      <el-table-column :label="$t('manage.name7')" prop="phone" sortable></el-table-column>
      <el-table-column :label="$t('manage.name8')" prop="email" sortable></el-table-column>
      <el-table-column :label="$t('manage.name9')" prop="updateTime" sortable></el-table-column>
      <el-table-column :label="$t('manage.name10')" prop="loginDate" sortable></el-table-column>
      <el-table-column :label="$t('manage.name11')" prop="loginIp" sortable></el-table-column>
      <el-table-column :label="$t('manage.name139')" prop="clientAuth" sortable>
        <template slot-scope="scope">
          <el-switch :value="scope.row.clientAuth.includes('2')"  active-color="#0f73e6" inactive-color="#dcdfe6" @change="changeSwitch(scope.row, $event)"> </el-switch>
      </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name12')" prop="status" sortable>
        <template slot-scope="scope">
          <div class="qiyong" v-if="scope.row.status">
            <div class="text">{{ $t('manage.name13') }}</div>
          </div>
          <div class="jinyong" v-else>
            <div class="text">{{ $t('manage.name14') }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name15')" width="188px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="bindingRoles(scope.row)" v-if="buttonPerms.indexOf('user/bindRole') > -1">{{ $t('manage.name16') }}</el-button>
          <el-button type="text" @click="editUser(scope.row)" v-if="buttonPerms.indexOf('user/update') > -1">{{ $t('manage.name17') }}</el-button>
          <el-button type="text" @click="delUser(scope.row)" v-if="buttonPerms.indexOf('user/delete') > -1" style="color:#ea4646">{{ $t('manage.name18') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <el-dialog :title="userInfo.userId ? $t('manage.name94') : $t('manage.name19')" v-if="userInfoDialog" :visible.sync="userInfoDialog" :close-on-click-modal ="false" :before-close="close" width="400px">
      <el-form ref="userFormRef" :model="userInfo" :rules="userInfo.userId ? userInfoRules1 : userInfoRules" label-width="100px">
        <el-form-item prop="loginName" :label="$t('manage.name20')">
          <el-input v-model="userInfo.loginName"  :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <el-form-item prop="loginPwd" :label="$t('manage.name21')">
          <el-input v-model="userInfo.loginPwd"  type="password" show-password :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <el-form-item prop="userName" :label="$t('manage.name22')">
          <el-input v-model="userInfo.userName" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <el-form-item prop="nickName" :label="$t('manage.name23')">
          <el-input v-model="userInfo.nickName" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <el-form-item prop="phone" :label="$t('manage.name24')">
          <el-input v-model="userInfo.phone" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <!-- <el-form-item prop="email" :label="$t('manage.name26')">
          <el-input v-model="userInfo.email" :placeholder="$t('public.name5')"></el-input>
        </el-form-item> -->
        <el-form-item prop="clientAuth" :label="$t('manage.name107')">
          <el-checkbox-group v-model="userInfo.clientAuth"  @change="handleCheckedChange">
            <el-checkbox label="2">{{ $t('manage.name139') }}</el-checkbox>
            <el-checkbox label="1">{{ $t('manage.name125') }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
         <el-form-item prop="roles" :label="$t('manage.name25')" v-if="isShowRole">
          <el-select v-model="userInfo.roles" :placeholder="$t('public.name1')">
            <el-option v-for="item in rolesOptions" :key="item.roleId" :label="item.roleName" :value="item.roleId"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="status" :label="$t('manage.name2')">
          <el-switch v-model="userInfo.status" active-color="#0f73e6" inactive-color="#dcdfe6"> </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="loading" type="primary" @click="submitForm">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="$t('manage.name16')" v-if="bindingRolesDialog" :visible.sync="bindingRolesDialog" :close-on-click-modal ="false" :before-close="close" width="400px">
      <el-form ref="rolesFormRef" :model="rolesInfo" label-width="120px">
        <el-form-item prop="roleIds" :label="$t('manage.name25')">
          <el-select v-model="rolesInfo.roleIds" :placeholder="$t('public.name1')">
            <el-option v-for="item in rolesOptions" :key="item.roleId" :label="item.roleName" :value="item.roleId"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="loading" type="primary" @click="bindRole">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { userList, userDelete, userSave, userInfo, userUpdate, sysroleList, updateUserClientAuth } from '@/api/manage.js'
import { userBindRole } from '@/api/user.js'
import { mapGetters } from 'vuex'
import { validateEmail, validatePass } from '@/utils/utils.js'
export default {
  computed: {
    ...mapGetters(['userinfo'])
  },
  data() {
    return {
      loginstatus: 1,
      queryInfo: {
        keyword: '',
        page: 1,
        limit: 10,
        status: 2
      },
      tableList: [],
      statusList: [
        {
          value: 2,
          label: this.$t('operate.name98')
        },
        {
          value: 0,
          label: this.$t('operate.name48')
        },
        {
          value: 1,
          label: this.$t('operate.name39')
        }
      ],
      total: 0,
      selectList: [],
      isShowRole: false,
      userInfoRules: {
        loginName: [
          {
            required: true,
            validator: validateEmail,
            trigger: 'blur'
          }
        ],
        loginPwd: [
          {
            required: true,
            validator: validatePass,
            trigger: 'blur'
          }
        ],
        clientAuth: [
          {
            required: true,
            message: this.$t('screen.name24'),
            trigger: 'blur'
          }
        ],
        roles: [
          {
            required: true,
            message: this.$t('screen.name25'),
            trigger: 'blur'
          }
        ]
      },
      userInfoRules1: {
        loginName: [
          {
            required: true,
            validator: validateEmail,
            trigger: 'blur'
          }
        ],
        clientAuth: [
          {
            required: true,
            message: this.$t('screen.name24'),
            trigger: 'blur'
          }
        ],
        roles: [
          {
            required: true,
            message: this.$t('screen.name25'),
            trigger: 'blur'
          }
        ]
      },
      userInfo: {
        loginName: '',
        loginPwd: '',
        userName: '',
        nickName: '',
        phone: '',
        email: '',
        clientAuth: [],
        tenantType: 0,
        roles: '',
        status: true
      },
      showMsgVisible: false,
      rolesInfo: {
        roleIds: '',
        userId: ''
      },
      showMsgallVisible: false,
      userInfoDialog: false,
      bindingRolesDialog: false,
      rolesOptions: [],
      loading: false,
      buttonPerms: ''
    }
  },
  created() {
    this.buttonPerms = localStorage.getItem('buttonPerms')
    // console.log('userinfo===', this.userinfo)
  },
  mounted() {
    this.getUserList()
  },
  methods: {
    getPageList() {
      this.queryInfo.page = 1
      this.queryInfo.limit = 10
      this.getUserList()
    },
    getUserList() {
      this.loading = true
      const data = {
        page: this.queryInfo.page,
        limit: this.queryInfo.limit,
        tenantType: 0
      }

      if (this.queryInfo.keyword) {
        data.keyword = this.queryInfo.keyword.trim()
      }

      if (this.queryInfo.status !== 2) {
        if (this.queryInfo.status === 0) {
          data.status = true
        } else {
          data.status = false
        }
      }

      userList(data)
        .then(res => {
          this.tableList = res.data.list
          this.total = res.data.total
          this.loading = false
        })
        .catch(() => {
          this.tableList = []
          this.total = 0
          this.loading = false
        })
    },
    handleCheckedChange() {
      this.isShowRole = false
      this.userInfo.clientAuth.map((item) => {
        if (item === '1') {
          this.isShowRole = true
        }
      })
    },
    changeSwitch(row, e) {
      const tip = row.clientAuth.includes('2') ? this.$t('manage.name140') : this.$t('manage.name141')
      this.$confirm(tip, this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          this.tableLoading = true
          var clientAuthList = []
          if (row.clientAuth.indexOf('1') > -1) {
            clientAuthList.push(1)
          }
          if (!row.clientAuth.includes('2')) {
            clientAuthList.push(2)
          }
          updateUserClientAuth({ userId: row.userId, clientAuth: clientAuthList.join(',') })
            .then((res) => {
              this.tableLoading = false
              this.getUserList()
            })
            .catch(() => {
              this.tableLoading = false
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.name34')
          })
        })
    },
    addUser() {
      this.isShowRole = false
      this.getSysroleList()
      this.userInfoDialog = true
    },
    delUser(row) {
      this.$confirm(this.$t('manage.name126'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          userDelete({
            id: row.userId + ''
          })
            .then(res => {
              if (res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$t('public.name30')
                })
                this.queryInfo.page = 1
                this.getUserList()
              }
            })
            .catch(() => {})
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.name31')
          })
        })
    },

    editUser(row) {
      userInfo({ id: row.userId + '' })
        .then(res => {
          this.userInfo = {
            userId: res.data.userId,
            loginName: res.data.loginName,
            loginPwd: '',
            userName: res.data.userName,
            nickName: res.data.nickName,
            phone: res.data.phone,
            email: res.data.email,
            status: res.data.status,
            roles: parseInt(row.roleId),
            tenantType: 0,
            clientAuth: row.clientAuth ? row.clientAuth.split(',') : []
          }
          this.userInfo.clientAuth.map((item) => {
            if (item === '1') {
              this.isShowRole = true
            }
          })
          this.getSysroleList()
          this.userInfoDialog = true
        })
        .catch(() => {})
    },
    bindRole() {
      userBindRole(this.rolesInfo)
        .then(res => {
          if (res.code === 200) {
            this.getUserList()
            this.close()
          }

          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    restQuery() {
      this.queryInfo = {
        keyword: '',
        page: 1,
        limit: 10,
        status: 2
      }
      this.getUserList()
    },
    close() {
      this.userInfoDialog = false
      this.bindingRolesDialog = false
      this.userInfo = {
        loginName: '',
        loginPwd: '',
        userName: '',
        nickName: '',
        phone: '',
        email: '',
        tenantType: 0,
        status: true,
        clientAuth: []
      }
      this.rolesInfo = {
        roleIds: '',
        userId: ''
      }
    },
    submitForm() {
      this.$refs.userFormRef.validate(async valid => {
        if (!valid) return
        this.loading = true
        if (Array.isArray(this.userInfo.clientAuth)) {
          this.userInfo.clientAuth = this.userInfo.clientAuth.join(',')
        }
        if (this.userInfo.userId) {
          userUpdate(this.userInfo)
            .then(res => {
              if (res.code === 200) {
                this.loading = false
                this.queryInfo.page = 1
                this.close()
                this.getUserList()
              } else {
                this.userInfo.clientAuth = this.userInfo.clientAuth.split(',')
              }
            })
            .catch(() => {
              this.userInfo.clientAuth = this.userInfo.clientAuth.split(',')
              this.loading = false
            })
        } else {
          userSave(this.userInfo)
            .then(res => {
              if (res.code === 200) {
                this.loading = false
                this.queryInfo.page = 1
                this.close()
                this.getUserList()
              } else {
                this.userInfo.clientAuth = this.userInfo.clientAuth.split(',')
              }
            })
            .catch(() => {
              this.userInfo.clientAuth = this.userInfo.clientAuth.split(',')
              this.loading = false
            })
        }
      })
    },

    bindingRoles(row) {
      this.bindingRolesDialog = true
      this.rolesOptions = []
      this.rolesInfo.userId = row.userId
      this.getSysroleList()
    },

    getSysroleList() {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 0
      }
      sysroleList(data)
        .then(res => {
          this.rolesOptions = res.data.list
        })
        .catch(() => {})
    },

    // 监听pagesizes的事件
    handleSizeChange(newSize) {
      this.queryInfo.limit = newSize
      this.getUserList()
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage
      this.getUserList()
    }
  }
}
</script>
<style lang="scss" scoped>
.systemuserlist-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  .search-layout {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .qiyong {
    width: 70px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #ebf6ed;
    color: #39ab4c;

    .text:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      background: #39ab4c;
      margin-right: 5px;
    }
  }

  .jinyong {
    width: 70px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #fcecec;
    color: #ea4646;

    .text:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      background: #ea4646;
      margin-right: 5px;
    }
  }
}
</style>
